import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { CarouselComponent } from './carousel/carousel.component';
import { FooterComponent } from './footer/footer.component';
import { OwnServicesComponent } from './own-services/own-services.component';
import { AboutSectionComponent } from './about-section/about-section.component';
import { BannerSectionComponent } from './banner-section/banner-section.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SubscribeComponent } from './subscribe/subscribe.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { environment } from 'src/environments/environment';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { SubscribeThankYouComponent } from './subscribe-thank-you/subscribe-thank-you.component';
import { CookieConsentBannerComponent } from './cookie-consent-banner/cookie-consent-banner.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MarketingConsentDialogComponent } from './marketing-consent-dialog/marketing-consent-dialog.component';
import { WeddingComponent } from './wedding/wedding.component';
import { LinkHubComponent } from './link-hub/link-hub.component';
import { ServicesPageComponent } from './pages/services-page/services-page.component';
import { AboutPageComponent } from './pages/about-page/about-page.component';
import { ContactPageComponent } from './pages/contact-page/contact-page.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    CarouselComponent,
    FooterComponent,
    OwnServicesComponent,
    AboutSectionComponent,
    BannerSectionComponent,
    SubscribeComponent,
    SubscribeThankYouComponent,
    CookieConsentBannerComponent,
    CookiePolicyComponent,
    PrivacyPolicyComponent,
    MarketingConsentDialogComponent,
    LinkHubComponent,
    WeddingComponent,
    ServicesPageComponent,
    AboutPageComponent,
    ContactPageComponent
  ],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    BrowserModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    FormsModule,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    ReactiveFormsModule,
    AppRoutingModule,
    MatDialogModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
